import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type CreateMediaVideoMutationVariables = Types.Exact<{
  payload: Types.createMediaVideoInput;
}>;

export type CreateMediaVideoMutation = { __typename?: 'Mutation'; createMediaVideo: { __typename?: 'MediaVideo'; id: string } };

export const CreateMediaVideoDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateMediaVideo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'createMediaVideoInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMediaVideo' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateMediaVideoMutationFn = Apollo.MutationFunction<CreateMediaVideoMutation, CreateMediaVideoMutationVariables>;

/**
 * __useCreateMediaVideoMutation__
 *
 * To run a mutation, you first call `useCreateMediaVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMediaVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMediaVideoMutation, { data, loading, error }] = useCreateMediaVideoMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateMediaVideoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMediaVideoMutation, CreateMediaVideoMutationVariables>) {
  return ApolloReactHooks.useMutation<CreateMediaVideoMutation, CreateMediaVideoMutationVariables>(CreateMediaVideoDocument, baseOptions);
}
export type CreateMediaVideoMutationHookResult = ReturnType<typeof useCreateMediaVideoMutation>;
export type CreateMediaVideoMutationResult = Apollo.MutationResult<CreateMediaVideoMutation>;
export type CreateMediaVideoMutationOptions = Apollo.BaseMutationOptions<CreateMediaVideoMutation, CreateMediaVideoMutationVariables>;
